module.exports = __webpack_public_path__ + "img/heating.ffba653e.jpg";